import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as model from "../../../models";

@Component({
	selector: 'ticket-quotas',
	templateUrl: "./ticket-quotas.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./ticket-quotas.scss")]
})
export class TicketQuotas {

	@Input() private ticketQuotaCollection: model.TicketQuota[]
	@Input() private selectedTicketQuota: model.TicketQuota
	@Output() private selectedTicketQuotaChange: EventEmitter<model.TicketQuota> = new EventEmitter<model.TicketQuota>();

	onChange(selectedTicketQuotaUuid: string) {
		if (selectedTicketQuotaUuid) {
			this.selectedTicketQuota = this.ticketQuotaCollection.find(element => element.uuid === selectedTicketQuotaUuid)
			this.selectedTicketQuotaChange.emit(this.selectedTicketQuota)
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-tickets/ticket-quotas/ticket-quotas.component.ts